// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_json = require("rescript/lib/js/js_json.js");

function getNonEmptyObj(jsObj) {
  if (jsObj == null) {
    return ;
  }
  var data = Js_json.decodeObject(jsObj);
  if (data === undefined) {
    return ;
  }
  var match = Object.keys(data).length;
  if (match !== 0) {
    return data;
  }
  
}

exports.getNonEmptyObj = getNonEmptyObj;
/* No side effect */
